import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';
import { IdeaType } from '../interfaces/responsedata.ts/datatypes';

@Pipe({
  name: 'getIdeaTypeNameById',
  standalone: false
})
export class GetIdeaTypeNameByIdPipe implements PipeTransform {
  dataService = inject(AppdataService);

  transform(value: string, lang: string = 'en'): string {
    let result = this.dataService.ideaTypes.find(t => t.id === value);
    if (result) {
      return result[("name_" + lang) as keyof IdeaType];
    } else {
      return value;
    }
  }


}
